import React, { useEffect } from "react";
import { Form, Input, InputNumber, Select } from 'antd';
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { 
	getJobRoleDetails, doJobRoleCreate, doJobRoleUpdate 
} from "../../../../redux/jobrole/jobRoleState";
import CrudButtons from "components/button/crudbuttons";
import { requiredField } from "utils/crudSagaHelper";
import DynamicList from "components/fields/DynamicList";
import { getLabel } from "utils";
import { MODULE_JOBROLES } from "variables/constants";

const JobRoleForm = ({
	recordData,
	getDetails,
	doCreate, 
	doUpdate, 
	onCancel,
	submitLabel,
	getRecord,
	...props
}) => {
	
  	const [form] = Form.useForm();
	const { recordId, mode } = props;
	const { TextArea } = Input;  	

	useEffect(() => {
		if(recordId){
			getRecord(recordId);
		}
	}, [recordId, getRecord]);

	useEffect(() => {
		if(recordData){
			form.resetFields();
			const { jobRole:jro_job_title, jro_count, ...rest } = recordData;

			const initialValues = {
				...rest,
				jro_id: recordData?.jro_id ?? "",
				jro_count: recordData?.jro_count ?? "",
				jro_key_responsibilities: Array.isArray(recordData?.jro_key_responsibilities)
					? recordData.jro_key_responsibilities
					: recordData.jro_key_responsibilities
					? JSON.parse(recordData.jro_key_responsibilities)
					: [""],
				jro_preferred_qualifications: Array.isArray(recordData?.jro_preferred_qualifications)
					? recordData.jro_preferred_qualifications
					: recordData.jro_preferred_qualifications
					? JSON.parse(recordData.jro_preferred_qualifications)
					: [""],
			};	
	        form.setFieldsValue(initialValues);

        }
    }, [recordData, form]);


  	const onSubmit = (formData) => {	
		console.log(formData);
    	try {  

			recordData.jro_id > 0 ? doUpdate(formData): doCreate(formData); 
    	} catch (error) {
      		console.error('Save failed:', error);
    	}
  	};
  
  	return (
    	<Form className="form"
			form={form} 
			layout="vertical"
			onFinish={onSubmit}
		>   
			<FormItem
				name="jro_id"
				hidden
			>
				<Input type="hidden"/>
			</FormItem>
			<div className="grid grid-cols-7 gap-y-2 gap-x-4 w-full">
				<FormItem className="font-medium mb-2 col-span-5"
					name="jro_job_title"
					label="Job Title"
					rules={[requiredField()]}
					
				>
					{mode !== 'view' ?
						<Input id="jro_job_title"
							className="input-field"
							maxLength={100}
							placeholder="Enter job title"
						/>
						: 
						<label className="text-base label-value dark:text-white">
							{recordData?.jro_job_title}
						</label>
					}
				</FormItem>
				<FormItem className="font-medium mb-2 col-span-2"
					name="jro_status_id"
					label="Status"
					rules={[requiredField()]}
				>
					{mode !== 'view' ?
						<Select id="jro_status_id"
							className="input-field"
							showSearch
							allowClear={true}
							options={recordData?.jobRoleStatusList}
						/>
						: 
						<label className="text-base label-value dark:text-white">
							{getLabel(recordData?.jobRoleStatusList, recordData?.jro_status_id)}
						</label>
					}	                
				</FormItem>
			</div>
			<div className="grid grid-cols-7 gap-y-2 gap-x-4 w-full">         
				<FormItem className="font-medium mb-2 col-span-1"
					name="jro_count"
					label="Count"
					rules={[requiredField()]}
				>
					{mode !== 'view' ?
						<InputNumber id="jro_count"
							className="input-field"
							type="text"
							placeholder="1"
							min={1}
						/>
						: 
						<label className="text-base label-value dark:text-white">
							{recordData?.jro_count}
						</label>
					}                
				</FormItem>
				<FormItem className="font-medium mb-2 col-span-2"
					name="jro_job_level_id"
					label="Job Level"
					rules={[requiredField()]}
				>
					{mode !== 'view' ?
						<Select id="jro_job_level_id"
							className="input-field"
							showSearch
							allowClear={true}
							options={recordData?.jobRoleLevelList}
						/>
						: 
						<label className="text-base label-value dark:text-white">
							{getLabel(recordData?.jobRoleLevelList, recordData?.jro_job_level_id)}
						</label>
					}	                
				</FormItem>
				<FormItem className="font-medium mb-2 col-span-4"
					label="Location"
					name="jro_location"
				>
					{mode !== 'view' ?
						<Input id="jro_location"
							className="input-field"
							type="text"
							placeholder="Enter location"
						/>
						: 
						<label className="text-base label-value dark:text-white">
							{recordData?.jro_location}
						</label>
					}
				</FormItem>
			</div>
			<FormItem className="font-medium  mb-2 w-full"
				name="jro_job_description"
				label="Job Description"
				rules={[requiredField()]}
				>
				{mode !== "view" ?
					<TextArea id="jro_job_description"
					className="input-field"
					rows={3}
					maxLength={500}		            		
					/>
					: 
					<label className="text-base label-value dark:text-white">
						{recordData?.jro_job_description}
					</label>
				}
			</FormItem>

			<DynamicList 
				name="jro_key_responsibilities"
				label="Key Responsibilities"
				placeholder="Enter responsibility"
				addButtonClass="text-gray-500 dark:text-white"
				mode={mode}
   				recordData={recordData}
			/>

			<DynamicList 
				name="jro_preferred_qualifications"
				label="Preferred Qualifications"
				placeholder="Enter qualification"
				addButtonClass="text-gray-500 dark:text-white"
				mode={mode}
   				recordData={recordData}
			/>

			<FormItem className="font-medium  mb-2 w-full"
				name="jro_add_info"
				label="Additonal Information"
				rules={[requiredField()]}
				>
				{mode !== "view" ?
					<TextArea id="jro_add_info"
					className="input-field"
					rows={3}
					maxLength={500}		            		
					/>
					: 
					<label className="text-base label-value dark:text-white">
						{recordData?.jro_add_info}
					</label>
				}
			</FormItem>

			<FormItem className="font-medium  mb-2 w-full"
				name="jro_how_to_apply"
				label="How to Apply"
				rules={[requiredField()]}
			>
				{mode !== "view" ?
					<TextArea id="jro_how_to_apply"
						className="input-field"
						rows={3}
						maxLength={500}		            		
					/>
					: 
					<label className="text-base label-value dark:text-white">
						{recordData?.jro_how_to_apply}
					</label>
				}
			</FormItem>

			<div className="w-full flex justify-end">
				{(mode === "edit") && (
					<CrudButtons
						mode={mode}
						recordId={recordData?.jro_id ?? 0}
						isModal={true}
						modalId={recordData?.jro_id > 0 ? 'edit_job_role' : 'add_job_role'}
						cancelLabel="Cancel"
						doHideModal={onCancel}
						submitLabel={submitLabel}
						moduleId={MODULE_JOBROLES}
					/>
				)}
			</div> 				 			
		</Form>	 	
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.jobRole.jobRoleDetails?.data,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getJobRoleDetails(id)),
  	doCreate: (data) => dispatch(doJobRoleCreate(data)),
  	doUpdate: (data) => dispatch(doJobRoleUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(JobRoleForm);
